import { GzAvailableItemsCardWebComponent } from './component/GzAvailableItemsCardWebComponent';

export { GzAvailableItemsCardWebComponent };
